import { colors } from '../../colors';
var accordion = {
  bodyBackgroundColor: colors.offWhite,
  iconColor: colors.dustyTeal,
  rowBackgroundColor: colors.overcast,
  textColorDark: colors.charcoalGrey,
  textColorLight: colors.white
};
export default accordion;